export interface SubtaskType {
  label: string;
  type: string;
}

export const SUBTASK_TYPES: SubtaskType[] = [
  { label: "Coding Challenges", type: "coding" },
  { label: "Video", type: "video" },
  { label: "Notes", type: "notes" },
  { label: "MCQ", type: "mcq" },
  { label: "Project Coding", type: "project_coding" }
];

export const SUBTASK_TYPES_WITH_LEVEL: SubtaskTypes[] = ["video", "notes"];

export type SubtaskTypes = "video" | "notes" | "mcq" | "coding" | "project_coding";

export const CODING_EDITOR_TYPES: SubtaskType[] = [
  { label: "Python Editor", type: "python_coding" },
  { label: "SQL Editor", type: "sql_coding" },
  { label: "Frontend Editor", type: "frontend_coding" }
];

/** Matches backend `question_types` enum values. */
export const QUESTION_TYPE = {
  MCQ: "mcq",
  CODING: "coding",
  PROJECT_CODING: "project_coding",
  FRONTEND_CODING: "frontend_coding",
  PYTHON_CODING: "python_coding",
  SQL_CODING: "sql_coding",
} as const;

export type QuestionTypeValue =
  (typeof QUESTION_TYPE)[keyof typeof QUESTION_TYPE];

/**
 * Content Status Configuration
 * Defines colors for content status indicators (Assigned=Red, Uploaded=Yellow, Approved=Green)
 */
export interface StatusConfigItem {
  key: string;
  color: string;
  title: string;
}

export const CONTENT_STATUS_CONFIG: StatusConfigItem[] = [
  { key: "assigned", color: "#dc3545", title: "Assigned" },
  { key: "uploaded", color: "#ffc107", title: "Uploaded" },
  { key: "approved", color: "#28a745", title: "Approved" }
];

/**
 * Project Status Color Mapping
 * Maps project statuses to colors based on content status colors
 */
export const PROJECT_STATUS_COLORS: Record<string, string> = {
  "WIP": CONTENT_STATUS_CONFIG.find(s => s.key === "assigned")?.color || "#dc3545",
  "Configured": CONTENT_STATUS_CONFIG.find(s => s.key === "uploaded")?.color || "#ffc107",
  "Published": CONTENT_STATUS_CONFIG.find(s => s.key === "approved")?.color || "#28a745"
};

/**
 * Action Type Constants
 * Use these constants instead of string literals for actionType checks
 */
export const ACTION_TYPE = {
  SELECT: "select",
  ASSIGN: "assign"
} as const;

export type ActionTypeValue = typeof ACTION_TYPE[keyof typeof ACTION_TYPE];